const tableTitleExpiredServices = {
  title: 'Overdue Services',
  placeholder: 'Search',
};

export default tableTitleExpiredServices;
